import React from 'react';
import classNames from 'classnames';
import { useField } from 'formik';
import Error from '../lib/Error';
import Container from '../lib/Container';

export default function CheckboxInput(props) {

    const {
        label,
        name,
        type = "text",
        autoComplete,
        disabled,
        onChange,
        readOnly,
        fieldId,
        columns,
        required
    } = props;


    const [field, meta] = useField({
        name,
        readOnly,
        type,
        id: fieldId || name,
        autoComplete
    });

    function onChangeHandler(event) {
        const value = event.target.value;

        if (onChange && typeof onChange === 'function') {
            onChange(value, name)
        }

        return field.onChange(event);
    }

    const InputClasses = classNames({
        "block w-6 h-6 rounded-lg bg-white shadow-sm focus:z-10 checked:bg-primary disabled:bg-light disabled:cursor-not-allowed disabled:opacity-30 mr-2": true,
        "border-line": !meta?.error,
        "has-error": meta?.error
    })

    const LabelClasses = classNames({
        "text-sm leading-none pt-1": true,
    })

    return (
        <Container columns={columns || 1}>
            <div className='flex'>
                <input 
                    {...field}
                    id={fieldId || name}
                    type={"checkbox"}
                    disabled={disabled}
                    className={InputClasses}
                    onChange={onChangeHandler}
                />
                {label &&
                    <label htmlFor={fieldId || name} className={LabelClasses}>
                    {label ? label : ''} {required ? ' *' : ''}
                </label>
                }
            </div>

            {meta?.error && (
                <Error error={meta.error}/>
            )}
        </Container>
    )
}
